import { useMutation, useQueryClient } from "@tanstack/react-query";
import { unAuthenticatedApiFetch } from "../APIClient";
import {
  SignupUserWithEmailRequestDto,
  SignupUserWithEmailResponseDto,
} from "../generated/generatedTypes";
import { getUtmFromCookie } from "../../utils/utm";

// export interface SignupUserWithEmailRequestDto {
//   name: string;
//   email?: string;
//   phone: string;
//   nickname: string;
//   password?: string;
// }
// export interface SignupUserWithEmailResponseDto {
//   access_token: string;
//   refresh_token: string;
//   expires_in: number;
//   token_type: string;
//   user: User;
// }

const signupWithEmail = async (
  data: SignupUserWithEmailRequestDto
): Promise<SignupUserWithEmailResponseDto> => {
  const utm = getUtmFromCookie();
  const response = await unAuthenticatedApiFetch("api/users/email-signup", {
    method: "POST",
    body: JSON.stringify({ ...data, ...(utm && { utm }) }),
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(
      error?.error?.message ||
        error?.message ||
        "Something went wrong signing up. Please try again shortly."
    );
  }
  return response.json();
};

export function useSignupWithEmail() {
  const queryClient = useQueryClient();
  return useMutation<SignupUserWithEmailResponseDto, Error, SignupUserWithEmailRequestDto>({
    mutationFn: signupWithEmail,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["myInfo"] });
    },
  });
}
